export enum ScrollType {
  'NONE' = 'NONE',
  'HORIZONTAL' = 'HORIZONTAL',
  'VERTICAL' = 'VERTICAL',
}

export const getCurrentScroll = ({
  ref,
  setScroll,
}: {
  ref: React.MutableRefObject<any>
  setScroll: React.Dispatch<React.SetStateAction<ScrollType>>
}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const carousel = ref.current.rootElement
  let startPos: { x: number; y: number }
  let endPos: { x: number; y: number }
  let isScrolling: boolean

  function touchMove(e: any) {
    if (isScrolling) {
      carousel.removeEventListener('touchmove', touchMove)
    }

    isScrolling = true

    const touch = e.targetTouches[0]

    endPos = {
      x: touch.pageX - startPos.x,
      y: touch.pageY - startPos.y,
    }
    if (Math.abs(endPos.x) <= Math.abs(endPos.y)) {
      setScroll(ScrollType.VERTICAL)
    } else {
      setScroll(ScrollType.HORIZONTAL)
    }
  }

  function touchEnd() {
    setScroll(ScrollType.NONE)
  }

  function touchStart(e: any) {
    isScrolling = false
    const touch = e.targetTouches[0] //The touches array object gets all the touches on the screen, taking the first touch
    startPos = {
      x: touch.pageX,
      y: touch.pageY,
    }

    carousel.addEventListener('touchmove', touchMove)
  }

  carousel.addEventListener('touchstart', touchStart)
  carousel.addEventListener('touchend', touchEnd)
}
